import { environment } from '../../environments/environment';

/**
 * Utility function to check if we're running in local development environment with mock data
 * @returns true if useMockData flag is enabled in environment
 */
export function isLocalEnvironment(): boolean {
  return 'useMockData' in environment && (environment as { useMockData?: boolean }).useMockData === true;
}

/**
 * Log a message with local environment indicator
 * @param message The message to log
 * @param emoji Optional emoji prefix
 */
export function logLocalEnvironment(message: string, emoji = '🧪'): void {
  if (isLocalEnvironment()) {
    console.log(`${emoji} [LOCAL] ${message}`);
  }
}